import React, { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import windowSize from 'react-window-size';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import Cookies from 'universal-cookie';

import NextSync from '../NextSync';
import { User } from '../User/User';
import Subscribe from '../Subscribe/Subscribe';
import { hasManageBilling } from '../../util/roles';
import { toggleNavigationShown } from '../../modules/App/AppActions';
import { joinAccount } from '../../modules/Auth/AuthActions';
import { getNotifications } from '../../modules/Notifications/NotificationsActions';

import { translate } from '../../util/translate';

import houseIcon from '../../assets/img/house-icon.svg';

// Import Images
import logo from '../../assets/img/nave-logo.svg';

import './Header.scss';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bannerUpdate: false
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    if (
      !this.props.wallmode &&
      !this.props.notificationsLoading &&
      !this.props.notificationsLoaded &&
      this.props.user &&
      this.props.user._id &&
      this.props.user._id !== 'temp'
    ) {
      this.props.getNotifications();
    }
  }

  componentDidUpdate() {
    if (
      !this.props.wallmode &&
      !this.props.notificationsLoading &&
      !this.props.notificationsLoaded &&
      this.props.user &&
      this.props.user._id &&
      this.props.user._id !== 'temp'
    ) {
      this.props.getNotifications();
    }
  }

  toggleMenu() {
    this.props.toggleNavigationShown(!this.props.navigationShown);
  }

  onRequest = acc => {
    this.props.joinAccount(acc.accountId, acc.iid);
  };

  onHandleStalledWebhooks = () => {
    if (this.props.user && this.props.user.host) {
      if (this.props.outside) { 
        // TODO: implement oauth1 token authentication flow in plugin
      } else {
        const cookies = new Cookies();
        cookies.set('backTo', window.location.pathname + window.location.search, {
          path: '/',
          maxAge: 60
        });
        window.location.replace(`/api/integrations/login${!!this.props.location.search ? this.props.location.search + '&' : '?'}h=${this.props.user.host}&cleanup=true`);
      }
    }
  }

  closeBanner = (id, enabledOn) => {
    localStorage.setItem(`notification-${id}-${enabledOn}`, false);
    this.setState({ bannerUpdate: !this.state.bannerUpdate });
  };

  renderBanner = () => {
    const { user, wallmode, notifications } = this.props;

    if (
      wallmode ||
      !user ||
      !user._id ||
      user._id === 'temp' ||
      !notifications ||
      !notifications.list ||
      !notifications.list.length
    ) {
      return;
    }

    const isAnnual = user.isAnnual && user.status === 'active';
    const isMonthly = !user.isAnnual && user.status === 'active';
    const isTrial = user.status === 'trial' && moment(user.trialEnd).isSameOrAfter(moment());
    const hasBillingAccess = user.permissions.manageBilling;
    const isEnrolled = notifications.enrolledSp;
    const isActualPlan = user.plan && user.plan.indexOf('-plan') > -1;

    const list = _(notifications.list)
      .filter(n => {
        const userStartDate = user.activatedAt ? user.activatedAt : user.createdAt;

        const startTime = moment(userStartDate).add(n.start_day, 'days');
        const endTime = moment(userStartDate).add(n.end_day, 'days');

        const isWithinTimeFrame = moment().isBetween(startTime, endTime);

        const isRollingPeriodActivated = isWithinTimeFrame && n.timeline.activated && user.activated;

        const isRollingPeriodTrial = isWithinTimeFrame && isTrial && n.timeline.trial;

        const show = !n.audience || (
          (n.audience[1] === true && hasBillingAccess) ||
          (n.audience[2] === true && isMonthly) ||
          (n.audience[3] === true && isAnnual) ||
          (n.audience[4] === true && isTrial) ||
          (n.audience[5] === true && isEnrolled) ||
          (n.audience[6] === true && isActualPlan)
        );

        const hide =
          n.audience &&
          ((n.audience[1] === false && hasBillingAccess) ||
            (n.audience[2] === false && isMonthly) ||
            (n.audience[3] === false && isAnnual) ||
            (n.audience[4] === false && isTrial) ||
            (n.audience[5] === false && isEnrolled) ||
            (n.audience[6] === false && isActualPlan));

        return (n.rolling_period && (isRollingPeriodActivated || isRollingPeriodTrial)) || (n.fixed_period && show && !hide);
      })
      .filter(n => {
        return !localStorage.getItem(`notification-${n._id}-${n.enabledOn}`);
      })
      .value();

    if (list.length) {
      const formatted = list[0].description
        .replace(/rel=\"noopener noreferrer\"/gm, 'rel="noopener noreferrer" target="_blank" style="color: #ffffff;"')
        .replace(/<p>/gm, '<span>')
        .replace(/<\/p>/gm, '</span>');

      const sanitized = DOMPurify.sanitize(formatted, { FORCE_BODY: true, ADD_ATTR: ['target'] });

      return (
        <div key={'static'} className='notification_bar notification'>
          <div className='container'>
            <span dangerouslySetInnerHTML={{ __html: sanitized }}></span>
            <Button className='btn-close' onClick={() => this.closeBanner(list[0]._id, list[0].enabledOn)}>
              &times;
            </Button>
          </div>
        </div>
      );
    }
  };

  render() {
    const {
      hideUser,
      showHome,
      showReport,
      showTeam,
      router,
      showSync,
      user,
      dashboardSelector,
      buttons,
      title,
      dashboard,
      dashboards,
      issue,
      wallmode,
      outside,
      stayHere
    } = this.props;

    const failedJob = (dashboard && dashboardSelector && _.first(dashboard.failedJobs)) || {};

    let failedJobMessage;
    if (issue) {
      if (router.location && router.location.pathname && router.location.pathname.startsWith('/update/')) {
        if (typeof issue === 'string') {
          failedJobMessage = issue;
        } else if (issue.data && issue.data.board && issue.data.board.msg) {
          failedJobMessage = translate(issue.data.board.msg);
        }
      }
    }
    if (failedJob.type) {
      failedJobMessage = translate(failedJob.type);
      if (
        ['not-authenticated', 'user-not-found', 'no-access', 'no-default-project', 'cf-endpoint-error'].indexOf(
          failedJob.type
        ) > -1
      ) {
        failedJobMessage = failedJobMessage.replace('{DASHBOARD_ID}', dashboard._id);
      }
    }
    
    const accessRequests = user && user.accessRequests && router.location && router.location.pathname !== '/users';

    const relatedAccount = user.relatedAccounts && user.relatedAccounts[0];

    const hasStalledWebhooks = user && user.config && user.config.hasStalledWebhooks;
    
    return [
      this.renderBanner(),
      // this.state.showBanner && (
      //   <div key={'static'} className='notification_bar notification'>
      //     <div className='container'>
      //       {user && user.isAnnual ? (
      //         <span>
      //           Black Friday Offer 🎁 Until Nov 30th, all licenses for the Sustainable Predictability program will be
      //           30% OFF! Use the code <b>NAVEBLACK22</b> at the checkout to apply your discount →{' '}
      //           <a className="white" target="_blank" href="https://getnave.com/enroll">
      //             https://getnave.com/enroll
      //           </a>
      //         </span>
      //       ) : (
      //         <span>
      //           Black Friday Offer 🎁 Until Nov 30th, all annual plans at Nave, as well as all licenses for the
      //           Sustainable Predictability program will be 30% OFF! Use the code <b>NAVEBLACK22</b> at the checkout to
      //           apply your discount →{' '}
      //           <a className="white" target="_blank" href="https://getnave.com/black">
      //             https://getnave.com/black
      //           </a>
      //         </span>
      //       )}
      //       <Button className='btn-close' onClick={this.closeBanner}>
      //         &times;
      //       </Button>
      //     </div>
      //   </div>
      // ),
      // this.state.showBanner && (
      //   <div key={'static'} className='notification_bar notification'>
      //     <div className='container'>
      //       <span>
      //         [Live Q&A with Sonya] Mar 7th, 3pm UTC! Join us on Zoom for one hour of Interactive Q&A goodness!{' '}
      //         <a className="white" target="_blank" href="https://www.addevent.com/event/cd16077255&utm_source=app&utm_medium=notification-message&utm_campaign=march-live-q&a">
      //           Add this event to your calendar →
      //         </a>
      //       </span>
      //       <Button className='btn-close' onClick={this.closeBanner}>
      //         &times;
      //       </Button>
      //     </div>
      //   </div>
      // ),
      !!accessRequests && !wallmode && (
        <div key={1} className='notification_bar notification'>
          <div className='container'>
            <span>
              Your colleagues requested access to your account.
              <br />
              You can review all pending requests in the{' '}
              <Link className="white" to="/users">
                Users Management
              </Link>{' '}
              page.
            </span>
          </div>
        </div>
      ),
      !!relatedAccount && !!relatedAccount.invited && !wallmode && (
        <div key={2} className='notification_bar notification'>
          <div className='container'>
            <span>
              You have a pending invitation to your corporate account,{' '}
              <Link className="white" onClick={() => this.onRequest(relatedAccount)}>
                join your team here
              </Link>
            </span>
          </div>
        </div>
      ),
      !!failedJobMessage && !wallmode &&(
        <div key={3} className='notification_bar'>
          <div className='container'>
            <span dangerouslySetInnerHTML={{ __html: failedJobMessage.replace(/\n/g, '<br />') }}></span>
          </div>
        </div>
      ),
      hasStalledWebhooks && !wallmode && !outside && (
        <div key={5} className='notification_bar'>
          <div className='container'>
            You have old connect app webhooks registered &nbsp;
            <Link className="white" onClick={this.onHandleStalledWebhooks}>Authenticate connect app to clean up</Link>
          </div>
        </div>
      ),
      <div key={4}
        className={`top_header ${!wallmode && hasManageBilling(user) && user.status !== 'active' && 'upgrade'}`} >
        {wallmode && (
          <div className='orange_header_logo'>
           <img src={logo} alt="" />
          </div>
        )}

        {/* Home button */}
        {(user.status && dashboards.length > 0  || showHome !== false) && !wallmode && (
          <div className='left_part'>
            {/*{showHome !== false && !stayHere && (
              <Link
                to={`${dashboard && dashboard._id ? `/dashboard/${dashboard._id}` : '/'}`}
                className='btn btn-sm btn-icon btn-secondary'
              >
                <img src={houseIcon} alt="" />
              </Link>
            )}F
            {showHome !== false && stayHere && (
              <Link                
                className='btn btn-sm btn-icon btn-secondary'
              >
                <img src={houseIcon} alt="" />
              </Link>
            )}
            {showReport && (
              <Link to="/report" className='btn btn-sm btn-outline-primary'>
                Executive Dashboard
              </Link>
            )}
            {showTeam && (
              <Link to="/" className='btn btn-sm btn-outline-primary'>
                Team Dashboards
              </Link>
            )}*/}
            {!!showSync && <NextSync />}
          </div>
        )}

        {/*<div className={`dropdown_position_center ${ notification_selector: false }`}>{dashboardSelector}</div>*/}
        <div className='center_part'>
          <React.Fragment>{dashboardSelector}</React.Fragment>
          <div className='title-dashboard'>{title}</div>
        </div>
        

        <div className='right_part'>
          {!hideUser && buttons}
          {!hideUser && !wallmode && user.status && <User />}
          {!hideUser && !wallmode && hasManageBilling(user) && user.status !== 'active' && !showTeam  && <Subscribe />}
        </div>
      </div>
    ];
  }
}

Header.propTypes = {
  dashboardSelector: PropTypes.node,
  buttons: PropTypes.node,
  title: PropTypes.node
};

const mapDispatchToProps = dispatch => {
  return {
    joinAccount: (acc, iid) => dispatch(joinAccount(acc, iid)),
    getNotifications: () => dispatch(getNotifications()),
    toggleNavigationShown: show => dispatch(toggleNavigationShown(show))
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
    notifications: state.notifications.notifications,
    notificationsLoading: state.notifications.isLoading,
    notificationsLoaded: state.notifications.isLoaded,
    outside: state.app.outside,
    wallmode: state.app.wallmode,
    navigationShown: state.app.navigationShown,
    user: state.auth.user,
    dashboards: state.dashboards.list,
    issue: state.dashboards.issue,
    dashboard: state.dashboards.selected
  };
}

export default withRouter(windowSize(connect(mapStateToProps, mapDispatchToProps)(Header)));
export { Header };
